export enum TerminalType {
    ALL = 'all',
    ECOM = 'ecom',
    POS = 'pos',
    SETTLEMENTS = 'settlements'
}
